import React from 'react';
import {
    Row, Col, Table,
    Form, FormGroup, FormControl, ControlLabel,
    Modal
} from 'react-bootstrap';
import Select from 'react-select';
import { API_ROOT } from '../../../variables/api-config';
import Button from '../../../elements/CustomButton/CustomButton.jsx';
import ModalUploadFile from '../../Components/ModalUploadFile.jsx';
import AlertError from '../../Components/AlertError.jsx';
import ModalBlockWrapper from '../../Components/ModalBlockWrapper';

class ModalTarea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tarea: null,
      alert: null,
      showUpload: false,
      dependCombobox: '',
      errorInicio: false,
      errorFin: false,
      errorNombre: false,
    };
    this.generateTableContent = this.generateTableContent.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.errorAlert = this.errorAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.uploadTaskFile = this.uploadTaskFile.bind(this);
    this.generateDependenciesOptions = this.generateDependenciesOptions.bind(this);
    this.displayDependTask = this.displayDependTask.bind(this);
    this.onChangeDependencie = this.onChangeDependencie.bind(this);
  }

  componentWillMount() {
    if (this.props.tarea) {
      let dependCombobox;
      if (this.props.tareasExt && this.props.tarea.depend !== '0') {
        dependCombobox = this.displayDependTask(this.props.tarea.depend);
      } else {
        dependCombobox = '';
      }
      console.log(this.props.tarea);
      const inicioParts = this.props.tarea.fechainicio.split('/');
      const finParts = this.props.tarea.fechafin.split('/');
      const tarea = {
        fechainicio: new Date(inicioParts[2], inicioParts[1] - 1, inicioParts[0]).toISOString().split('T')[0],
        fechafin: new Date(finParts[2], finParts[1] - 1, finParts[0]).toISOString().split('T')[0],
        archivos: this.props.tarea.archivos,
        depend: this.props.tarea.depend,
        id: this.props.tarea.id,
        nombre: this.props.tarea.nombre,
        porcentaje: this.props.tarea.porcentaje,
        proyectoid: this.props.tarea.proyectoid,
      }
      this.setState({ tarea, dependCombobox });

    } else {
      this.setState({
        tarea: {
          nombre: '',
          fechainicio: '',
          fechafin: '',
          porcentaje: '',
          id: null,
          archivos: [],
          depend: '0',
        },
      });
    }
  }

  saveTask() {
    let error = false;
    if (!this.state.tarea.nombre || this.state.tarea.nombre === '') {
      error = true;
      this.setState({errorNombre: true});
    }
    if (!this.state.tarea.fechainicio || this.state.tarea.fechainicio === '') {
      error = true;
      this.setState({errorInicio: true});
    }
    if (!this.state.tarea.fechafin || this.state.tarea.fechafin === '') {
      error = true;
      this.setState({errorFin: true});
    }

    if (error) {
      this.errorAlert(
        <div>Uno o mas campos requeridos contienen errores o no fueron completados!</div>
      );
    } else {
      this.props.saveChanges(this.state.tarea);
    }
  }

  onChangeDependencie(value) {
    const auxState = this.state.tarea;
    auxState['depend'] = value ? value.value : '0';
    this.setState({dependCombobox: value, tarea: auxState});
  }

  displayDependTask(id) {
    const tareasExternas = [...this.props.tareasExt];
    const tarea = tareasExternas.find((item) => item.id === id);
    return {value: tarea.id, label: tarea.nombre};
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  errorAlert(message) {
    this.setState({
      alert: (
        <AlertError hideAlert={this.hideAlert} message={message} />
      )
    });
  }

  generateTableContent() {
    const html = [];
    this.state.tarea.archivos.forEach((archivo, index) => {
      html.push(
        <tr key={index}>
          <td className="text-center">{archivo.nombre}</td>
          <td>{archivo.descripcion}</td>
          <td className="text-right">
            {archivo.id &&
              <a href={`${API_ROOT}/project/task/download/file?id=${archivo.id}`}>
                <i className="fa fa-download"></i>
              </a>
            }
          </td>
        </tr>
      )
    });
    return html;
  }

  handleOnChange(value, tag, callback) {
    const auxState = this.state.tarea;
    auxState[tag] = value;
    if (tag === 'fechainicio' || tag === 'fechafin') {
      auxState['depend'] = '0';
      this.setState({ dependCombobox: ''});
    }
    this.setState({ tarea: auxState });
    if (callback) {
      callback();
    }
  }

  uploadTaskFile(data) {
    this.props.proyectService
      .uploadTaskFile(data, this.state.tarea.id)
      .then(res => {
        const auxState = this.state.tarea;
        auxState.archivos.push(
          {
            nombre: data.name,
            descripcion: data.description,
          }
        );
        this.setState({tarea: auxState, showUpload: false });
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Archivo cargado satisfactoriamente!</div>), 10);
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se subia el archivo, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  generateDependenciesOptions(disabled) {
    if (disabled) { // no devolver opciones si el select esta deshabilitado
      return [];
    }
    const tareas = [...this.props.tareasExt];
    if (tareas.length === 0) return []; // no hay tareas preexistentes
    if (this.state.tarea.id) {  // remover tarea actual de las opciones en caso de ser edit
      const currentTarea = tareas.find((item) => item.id === this.state.tarea.id);
      var index = tareas.indexOf(currentTarea);
      if (index !== -1) tareas.splice(index, 1);
    }
    // filtrar tareas seleccionables basado en fechas
    const currentFechaInicio = new Date(this.state.tarea.fechainicio.replace(/-/g, '/'));
    tareas.forEach((item, index) => {
      const itemFechaInicio = new Date(item.fechainicio.replace(/-/g, '/'));
      if (itemFechaInicio > currentFechaInicio) {
        tareas.splice(index, 1);
      }
      if (item.depend === this.state.tarea.id) {
        tareas.splice(index, 1);
      }
    });
    const options = tareas.map((tarea) => {
      return {value: tarea.id, label: tarea.nombre};
    });
    return options;
  }

  render() {
    const disabledSelect = !this.state.tarea.fechainicio || this.state.tarea.fechainicio === ''
                        || !this.state.tarea.fechafin || this.state.tarea.fin === '';
    return (
      <div>
        <Modal show bsSize="large" onHide={this.props.closeModal}>
          <ModalBlockWrapper
            content={
              <div>
                <Modal.Header closeButton>
                  <Modal.Title>{this.props.tarea ? 'Editar tarea' : 'Nueva tarea'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col md={4}>
                      <Form>
                        <FormGroup validationState={this.state.errorNombre ? 'error': null}>
                          <ControlLabel>{'Nombre'}</ControlLabel>
                          <FormControl
                            type="text"
                            value={this.state.tarea.nombre}
                            onChange={(e) => this.handleOnChange(e.target.value, 'nombre', () => this.setState({errorNombre: false}))}
                          />
                        </FormGroup>
                        <FormGroup validationState={this.state.errorInicio ? 'error': null}>
                          <ControlLabel>{'Fecha Inicio'}</ControlLabel>
                          <FormControl
                            type="date"
                            value={this.state.tarea.fechainicio}
                            onChange={(e) => this.handleOnChange(e.target.value, 'fechainicio', () => this.setState({errorInicio: false}))}
                          />
                        </FormGroup>
                        <FormGroup validationState={this.state.errorFin ? 'error': null}>
                          <ControlLabel>{'Fecha Fin'}</ControlLabel>
                          <FormControl
                            type="date"
                            value={this.state.tarea.fechafin}
                            onChange={(e) => this.handleOnChange(e.target.value, 'fechafin', () => this.setState({errorFin: false}))}
                          />
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>{'% Completo'}</ControlLabel>
                          <FormControl
                            type="number"
                            value={this.state.tarea.porcentaje}
                            onChange={(e) => this.handleOnChange(e.target.value, 'porcentaje')}
                          />
                        </FormGroup>
                        {this.props.tareasExt &&
                          <FormGroup>
                            <ControlLabel>{'Dependencias'}</ControlLabel>
                            <Select
                              disabled={disabledSelect}
                              placeholder="Seleccione una tarea"
                              closeOnSelect={true}
                              name="equipmentSelect"
                              value={this.state.dependCombobox}
                              options={this.generateDependenciesOptions()}
                              onChange={(value) => this.onChangeDependencie(value)}
                            />
                            {disabledSelect &&
                              <small className="text-danger">Ingrese fechas previo a seleccionar dependencia</small>
                            }
                          </FormGroup>
                        }
                      </Form>
                    </Col>
                    <Col md={8}>
                      {this.state.tarea.archivos.length > 0 ?
                        <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                          <Table responsive={true}>
                            <thead>
                              <tr>
                                <th className="text-center">Nombre</th>
                                <th>Descripcion</th>
                                <th className="text-right"></th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.generateTableContent(disabledSelect)}
                            </tbody>
                          </Table>
                        </div> :
                        <div>No hay archivos</div>
                      }
                      <div style={{textAlign:'right', paddingRight:'15px', paddingTop: '10px'}}>
                        <Button
                          bsStyle="info" bsSize="sm" fill wd onClick={() => this.setState({ showUpload: true })}
                          disabled={!this.state.tarea.id}
                        >
                          Cargar Archivo
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button simple onClick={this.props.closeModal}>
                    Cancelar
                  </Button>
                  <Button
                    bsStyle="success" fill onClick={() => this.saveTask()}
                  >
                    Guardar
                  </Button>
                </Modal.Footer>
              </div>
            }
          />
        </Modal>
        {this.state.showUpload &&
          <ModalUploadFile
            closeUpload={() => this.setState({showUpload: false})}
            saveFile={this.uploadTaskFile}
          />
        }
        {this.state.alert}
      </div>
    );
  }
}

export default ModalTarea;



// WEBPACK FOOTER //
// ./src/views/Incubation/IncubationPage/ModalTarea.jsx